/**
 * Creates a URL-safe slug from text.
 * Used for feature params, FAQ params, and URL path segments.
 * @param text - Input string (null/undefined returns empty string)
 * @returns URL-safe slug or empty string for invalid input
 */
export const createSlug = (text: string | null | undefined): string => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
